import { CitesImportSpeciesTransaction } from 'src/app/core/models/cites/cites-import-species/CitesImportSpeciesTransaction';
import { CitesServiceRequestStore } from '../shared/base/CitesServiceRequestStore';

export class CitesImportSpeciesStore 
    extends CitesServiceRequestStore<CitesImportSpeciesTransaction>{}
